import { AddUserUpdateInputNames } from "@gik/inkind-page/enums/AddUserUpdateInputNames";
import { AddVideoInputNames } from "@gik/inkind-page/enums/AddVideoInputNames";
import { PageInformationInputNames } from "@gik/inkind-page/enums/PageInformationInputNames";
import type { FormSchemaEntry } from "@gik/ui-legacy/Form";

// FIXME: i18n

export const inkindPageInfoSchema: () => FormSchemaEntry[] = () => [
	{
		label: "Page title",
		type: "text",
		name: PageInformationInputNames.TITLE,
		placeholder: `e.g. Love for Layla, Supporting the Turners`,
		required: true,
	},
	{
		label: "Story",
		type: "textarea",
		name: PageInformationInputNames.STORY,
		props: {
			rows: 10,
		},
		placeholder: `Tell your visitors why you've started this page. Who is needing support and why? What forms of support would be most helpful? Is there anything else important for them to know? You can update this text at any time by logging in as the organizer and updating your Give InKind Page.

e.g. Love for Layla supports the Turner family as they celebrate the life of their beautiful daughter. Let's rally around them and show them how loved they are! Right now we want to make sure they are well fed, and we will update this page as their needs change. Thank you for your support!`,
	},
	{
		label: "Special Notes",
		type: "textarea",
		name: PageInformationInputNames.NOTES,
		props: {
			rows: 5,
		},
		placeholder: `This is a good place to share dietary or visiting restrictions, or anything else others should be aware of.

e.g. Peanut allergy! No spicy foods or shellfish. Also, please no sick visitors. If you have any doubt, call first. Thank you!`,
	},
];

export const addUserUpdateSchema: () => FormSchemaEntry[] = () => [
	{
		type: "date-picker",
		name: AddUserUpdateInputNames.DATE,
		props: {
			type: "button",
			allowPastDates: true,
			buttonProps: {
				tooltip: "Change date",
				size: "xs",
			},
		},
	},
	{
		type: "text",
		name: AddUserUpdateInputNames.TITLE,
		placeholder: "Enter a title for your update...",
		maxLength: 100,
		required: true,
	},
	{
		type: "textarea",
		name: AddUserUpdateInputNames.CONTENT,
		placeholder: "Share your latest news...",
		maxLength: 5000,
		props: {
			maxLength: 5000,
			maxLengthDisplay: true,
			maxLengthWarningSensitivity: 1000,
			autoGrow: true,
			rows: 5,
		},
		required: true,
	},

	{
		name: "label1",
		type: "plaintext",
		label: "Send Update to:",
	},
	{
		type: "checkbox",
		name: AddUserUpdateInputNames.SEND_OPTIONS_PAGE,
		props: {
			label: "Page (default)",
			disabled: true,
		},
	},
	{
		type: "checkbox",
		name: AddUserUpdateInputNames.SEND_OPTIONS_EMAIL,
		props: {
			label: "Email Supporters & Followers",
		},
	},
	{
		type: "checkbox",
		name: AddUserUpdateInputNames.SEND_OPTIONS_FACEBOOK,
		props: {
			label: "Facebook",
		},
	},
	{
		type: "checkbox",
		name: AddUserUpdateInputNames.SEND_OPTIONS_TWITTER,
		props: {
			label: "Twitter",
		},
	},
];

// eslint-disable-next-line
const youtubeRegex =
	/^http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-_]*)(&(amp;)?‌​[\w?‌​=]*)?/;
const vimeoRegex = /^http(?:s?):\/\/(?:www\.)?vimeo\.com\/(.+)\/(.+)$/;
export const addVideoFormSchema: FormSchemaEntry[] = [
	{
		type: "text",
		name: AddVideoInputNames.VIDEO_LINK,
		placeholder: "Paste YouTube or Vimeo link here",
		customValidation: [
			{
				validate: (value: string) =>
					!youtubeRegex.test(value) && !vimeoRegex.test(value),
				message: "This link is not a valid YouTube or Vimeo video URL",
			},
		],
	},
];
